import axios from '../config/axios';
import API_ENDPOINTS from '../config/api';

const postS9Chat = async (body) => {
  const response = await axios.post(API_ENDPOINTS.s9.chat, body, {
    timeout: 600000,
  });
  return response.data;
};

const postS9ResumeEditing = async (body) => {
  const response = await axios.post(API_ENDPOINTS.s9.resumeEditing, body);
  return response.data;
};

const postS9ResetWorkspace = async (body) => {
  const response = await axios.post(API_ENDPOINTS.s9.resetWorkspace, body);
  return response.data;
};

const getS9Workspace = async ({ projectId, studyId = '', userId = '' }) => {
  const response = await axios.get(API_ENDPOINTS.s9.workspace, {
    params: { projectId, studyId, userId },
  });
  return response.data;
};

const publishS9Version = async ({ projectId, studyId = '', changeNote = '', workspace = null }) => {
  const response = await axios.post(API_ENDPOINTS.s9.publish, {
    projectId,
    studyId,
    changeNote,
    workspace,
  });
  return response.data;
};

const listS9Versions = async ({ projectId, studyId = '' }) => {
  const response = await axios.get(API_ENDPOINTS.s9.versions, {
    params: { projectId, studyId },
  });
  return response.data;
};

const getS9Version = async ({ projectId, studyId = '', versionNumber }) => {
  const response = await axios.get(API_ENDPOINTS.s9.version(versionNumber), {
    params: { projectId, studyId },
  });
  return response.data;
};

const rollbackS9Version = async ({ projectId, studyId = '', versionNumber, changeNote = '' }) => {
  const response = await axios.post(API_ENDPOINTS.s9.rollback(versionNumber), {
    projectId,
    studyId,
    versionNumber,
    changeNote,
  });
  return response.data;
};

const getLatestS9Soa = async ({ projectId, studyId = '' }) => {
  const response = await axios.get(API_ENDPOINTS.s9.latest, {
    params: { projectId, studyId },
  });
  return response.data;
};

const pushSoaToDataPlatform = async ({ projectId, studyId = '' }) => {
  const response = await axios.post(API_ENDPOINTS.s9.pushToDataPlatform, { projectId, studyId });
  return response.data;
};

const s9AssessmentScheduleService = {
  postS9Chat,
  postS9ResumeEditing,
  postS9ResetWorkspace,
  getS9Workspace,
  publishS9Version,
  listS9Versions,
  getS9Version,
  rollbackS9Version,
  getLatestS9Soa,
  pushSoaToDataPlatform,
};

export default s9AssessmentScheduleService;
